import yxpapi from '@yxpapi';

export default new yxpapi.JAVAAPI({
    /* 根据当前登陆人员获取进入的应用 */
    install: {
        url: '/api/crm/common/install',
        method: 'get',
    },
    /* 关键字搜索机构 */
    listOrgByKeywords: {
        url: '/api/user/org/listOrgByKeywords',
        method: 'get',
    },
    /* 通过loginName搜索人员 */
    searchUser: {
        // url: '/api/user/account/search',
        url: '/api/user/account/searchByNameOrPhone',
        method: 'get',
    },
    /* 站点列表 */
    getWebsiteList: {
        url: '/api/crm/website/list',
        method: 'get',
    },
    /* 站点启用禁用 */
    updateValid: {
        url: '/api/crm/website/updateValid',
        method: 'post',
    },
    /* 生成访问地址 */
    generateAddress: {
        url: '/api/crm/website/generateAddress',
        method: 'post',
    },
    /* 站点信息保存 */
    saveWebsite: {
        url: '/api/crm/website/save',
        method: 'post',
        options: {
            headers: {
                'Content-Type': 'application/json',
            },
        },
    },
    /* 获取站点信息 */
    websiteInfo: {
        url: '/api/crm/website/info',
        method: 'get',
    },
    /* 站点信息 - 维护人员列表 */
    maintainers: {
        url: '/api/crm/website/maintainers',
        method: 'get',
    },
    /* 站点信息 - 添加维护人员 */
    addBatch: {
        url: '/api/crm/website/maintainer/addBatch',
        method: 'post',
        options: {
            headers: {
                'Content-Type': 'application/json',
            },
        },
    },
    /* 站点信息 - 删除维护人员 */
    deleteUsers: {
        url: '/api/crm/website/maintainer/delete',
        method: 'get',
    },
    /* 编辑站长 */
    updateStationmaster: {
        url: '/api/crm/website/updateStationmaster',
        method: 'post',
    },
    switchInstall: {
        url: '/api/crm/common/switch',
        method: 'post',
        options: {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        },
    },
});
